import * as Yup from 'yup'
import {Formik, Form, Field} from 'formik'
import {useListView} from '@/components/table/core/ListViewProvider'
import {FlatOffer} from '../../core/_models'
import {updateOffer} from '../../core/_requests'
import {
  InputText,
  Checkbox,
  FormActions
} from '@/components/form'
import {handleErrors} from '@/components/form/_utils'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'

const schema = Yup.object().shape({
  'offer': Yup.object().shape({
    'credits': Yup.number().min(1, 'Minimum value 1').required('Credits is required'),
  })
})

const OfferForm = () => {
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()
  const offer = itemForUpdate as FlatOffer
  const {refetch} = useQueryResponse()
  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }

  return (
    <Formik
      initialValues={offer}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          await updateOffer(values._id, values.offer)

          close()
          refetch()
        } catch (e: any) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {(props) => {
        return (
          <Form id="edit-offer" className='form'>
            <div className={'row'}>
              <div className={'col-6'}>
                <Field
                  name="offer.amount"
                  id="amount"
                  type="number"
                  component={InputText}
                  label={`Amount in ${offer.offer.currency}`}
                  disabled={true}
                />
              </div>
              <div className={'col-6'}>
                <Field
                  name="offer.payout"
                  id="payout"
                  type="number"
                  component={InputText}
                  label={`Payout in ${offer.offer.currency}`}
                  disabled={true}
                />
              </div>
            </div>

            <div className='separator separator-dashed my-5'></div> 

            <div className={'row'}>
              <div className={'col-6'}>
                <Field
                  id='enabled'
                  name="offer.enabled"
                  component={Checkbox}
                  label="Enabled"
                  defaultChecked={offer.enabled}
                />
              </div>

              <div className={'col-6'}>
                <Field
                  id='discrete'
                  name="offer.discrete"
                  component={Checkbox}
                  label="Discrete"
                  defaultChecked={offer.offer.discrete}
                />
              </div>
            </div>

            <div className='separator separator-dashed my-5'></div> 

            <div className={'row'}>
              <div className={'col-12'}>
                <Field
                  name="offer.credits"
                  id="credits"
                  type="number"
                  component={InputText}
                  label="Credits"
                  min="1"
                  step="1"
                  inputMode="numeric"
                  pattern="\d*"
                />
              </div>
            </div>

            <Field
              component={FormActions}
              close={close}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export {OfferForm}
